module.exports = __webpack_public_path__ + "img/free-day-table-icon.c9d84cf3.svg";